import { createSlice } from "@reduxjs/toolkit";

export const initialState = 
{
  visibleTreatments: []
}

export const treatmentsSlice = createSlice({
  name: 'treatments',
  initialState,
  reducers: {
    setTreatments: (state, action) => {
      state.visibleTreatments = action.payload;
    }
  }
});

export const {setTreatments} = treatmentsSlice.actions;

export default treatmentsSlice.reducer;